import { TextGradientTokens } from '../../theme/index.types';

export const applyGradientStyles = (gradient: TextGradientTokens) => ({
  color: undefined,
  background: `var(--${gradient})`,
  backgroundClip: 'text',
  textFillColor: 'transparent',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
});
